import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import { Link, useParams } from "react-router-dom";
import { DateFormater } from "../GlobalFunctions";

const ProjectInspections = () => {
    const { project_id } = useParams()
    const { apiURL, apiHeaderJson, } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loadingList, setLoadingList] = useState(true);

    const GetList = () => {
        const headers = apiHeaderJson;
        try {
            axios.get(`${apiURL}api/GetProjectVisits`, { params: { project_id, page, limit }, headers })
                .then((response) => {
                    const { data, success, next, prev, page: currentPage, total_records, total_pages } = response.data;

                    if (success) {
                        setRows(data);
                        setNext(next);
                        setPrev(prev);
                        setPage(currentPage);
                        setTotalRecords(total_records);
                        setTotalPages(total_pages);
                    }
                });
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingList(false);
        }
    }

    useEffect(() => {
        GetList()
    }, [project_id, page, limit])

    return (
        <div className="col-xxl-12">
            <div className="card">
                {
                    loadingList ? <ContentLoader /> :
                        <div className="card-body">
                            <div className="card-header d-flex align-items-center mb-4">
                                <h5 className="card-title flex-grow-1 mb-0">Inspectoins List</h5>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        <table className="table table-borderless align-middle mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center">ID</th>
                                                    <th className="text-center">Visit By</th>
                                                    <th className="text-center">Visit Remark</th>
                                                    <th className="text-center">Visit Date</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>

                                            {rows.length !== 0 ? (
                                                <>
                                                    <tbody>
                                                        {
                                                            rows.map((row) => (
                                                                <tr key={row.project_visit_id} className="text-center">
                                                                    <td className="text-center">{row.project_visit_id}</td>
                                                                    <td className="text-center">{row.profile_name}</td>
                                                                    <td
                                                                        className="text-center"
                                                                        title={row?.visit_remark || ""}
                                                                    >
                                                                        {row?.visit_remark?.length > 10
                                                                            ? `${row.visit_remark.slice(0, 10)}...`
                                                                            : row?.visit_remark || "-"}
                                                                    </td>
                                                                    <td className="text-center">{DateFormater(row.visit_datetime)}</td>
                                                                    <td>
                                                                        <Link
                                                                            to={`/InspectionInfo/${row.project_visit_id}`}
                                                                            className="btn btn-sm btn-info"
                                                                        >
                                                                            <i className="ri-eye-line"></i>
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                    <tfoot className="table-light">
                                                        <tr>
                                                            <th colSpan={10}>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    {/* PREV */}
                                                                    <button
                                                                        className="btn btn-warning btn-label"
                                                                        onClick={() => prev && setPage(page - 1)}
                                                                        disabled={!prev}
                                                                    >
                                                                        <i className="ri-arrow-left-line label-icon me-2"></i> Previous
                                                                    </button>

                                                                    {/* Info */}
                                                                    <small>
                                                                        Total Records: {totalRecords} | Total Pages: {totalPages} |
                                                                        Current Page: {page}
                                                                    </small>

                                                                    {/* Page Select */}
                                                                    <select
                                                                        className="form-select w-auto"
                                                                        value={page}
                                                                        onChange={(e) => setPage(Number(e.target.value))}
                                                                    >
                                                                        {Array.from({ length: totalPages }, (_, i) => (
                                                                            <option key={i + 1} value={i + 1}>
                                                                                {i + 1}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {/* NEXT */}
                                                                    <button
                                                                        className="btn btn-primary btn-label"
                                                                        onClick={() => next && setPage(page + 1)}
                                                                        disabled={!next}
                                                                    >
                                                                        Next <i className="ri-arrow-right-line label-icon ms-2"></i>
                                                                    </button>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </tfoot>
                                                </>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="8">
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

export default ProjectInspections